import React, { useContext, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import PezodeProductList from "./list/PezodeProductList";
import { ButtonToolbar, notifyToast, ToastType } from "../../../components";
import { savePezode } from "../api-handler/api-handler";
import { DisplaySpinnerContext, RouteGuardContext, TabPanelContext } from "../../../context/ContextIndex";
import { selectSessionConfig } from "../../../store/store-selector";
import PezodeProductCreate from "./create/PezodeProductCreate";
import { setBackDropLoader } from "../../../components-old/ComponentsIndex";

const PezodeProductView = () => {
  const navigate = useNavigate();
  const _tabContextObject = useContext(TabPanelContext);
  const routeGuardContext = useContext(RouteGuardContext);
  const _tabContext = _tabContextObject.getTabFormContext();
  const editPezodeId = _tabContext.editPezodeId;

  const spinnerCtx = useContext(DisplaySpinnerContext);
  const settingsConfig = useSelector(selectSessionConfig);
  const [showForm, setShowForm] = useState(false);
  const [isFormValid, setIsFormValid] = useState(false);

  const handleAddClick = () => {
    setShowForm(true);
  };

  //on cancel of create pezode range form
  const handleCancelForm = () => {
    _tabContextObject.setTabFormContext({
      data: {
        ..._tabContext.data,
        selectedConsumableProduct: null,
      },
    });
    setShowForm(false);
  };

  const onCancel = () => {
    try {
      navigate("/pezodelist");
    } catch (err) {
      alert(err);
    }
  };

  //on submit of pezode group
  const onSubmit = async () => {
    console.log("onPezodeSubmit");
    try {
      spinnerCtx.setLoadingIndicator(true);
      routeGuardContext.setFormState(false);
      const status = await savePezode(_tabContext.data, {
        editPezodeId,
        settingsConfig,
        formdata: _tabContext.prevData,
      });

      if (status?.responseStatus === 200) {
        notifyToast("Sent for approval", ToastType.SUCCESS);
        spinnerCtx.setLoadingIndicator(false);
        onCancel();
      } else {
        notifyToast("Pezode creation failed", ToastType.ERROR);
        spinnerCtx.setLoadingIndicator(false);
      }
    } catch (err) {
      spinnerCtx.setLoadingIndicator(false);
      alert(err);
    }
  };

  //on submit of replacement device form
  const handleFormSubmit = () => {
    setShowForm(false);
  };

  useEffect(() => {
    routeGuardContext.setFormState(_tabContext?.isDirty);
    setIsFormValid(_tabContext?.isDirty);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showForm, _tabContext?.isDirty]);

  return (
    <>
      {!showForm ? (
        <>
          {setBackDropLoader(spinnerCtx.isLoading)}
          <PezodeProductList onAddClick={handleAddClick} setShowForm={setShowForm} />
          <ButtonToolbar
            onCancel={onCancel}
            onSubmit={onSubmit}
            isFormValid={isFormValid ? true : false}
            isWithAppForm={false}
          />
        </>
      ) : (
        <PezodeProductCreate onSubmit={handleFormSubmit} onCancel={handleCancelForm} />
      )}
    </>
  );
};

export default PezodeProductView;
